<template>
  <div class="card-layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CardLayout"
}
</script>

<style lang="stylus">
.card-layout {
  margin-top 24px
  margin-bottom 24px
}
</style>